import React, { useState } from 'react';
import { Inscription } from '@common-fe/common-fe';

import PreviewPaymentDocument from '@/modules/employee/TransactionDetails/components/TransactionPaymentDetails/components/PreviewPaymentDocument/PreviewPaymentDocument';

interface Props {
  fileName: string;
  filePath: string;
}

const DocumentPreviewLink: React.FC<Props> = ({ fileName, filePath }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Inscription
        color="navigationAccent"
        weight="bold"
        lineHeight="20px"
        onClick={() => setIsOpen(true)}
        style={{ cursor: 'pointer' }}
      >
        {fileName}
      </Inscription>

      {isOpen && (
        <PreviewPaymentDocument
          paymentDocumentPath={filePath}
          isDocPreviewModalVisible={isOpen}
          setIsDocPreviewModalVisible={setIsOpen}
        />
      )}
    </>
  );
};

export default DocumentPreviewLink;
